export enum PercentileLevel {
  TopFive = 5,
  BottomTen = 90,
}
